// extracted by mini-css-extract-plugin
module.exports = {"title":"revenue-title-24466t","content":"revenue-content-1sW7oe"};